import { useSelector } from 'react-redux';
import { selectHasReadMatchlistsPermission } from 'app/modules/session/selectors';
import { useQuery } from '@tanstack/react-query';
import { post } from 'app/shared/utils/fetchr';
import { MATCHLIST_QUERY_KEYS } from 'app/modules/matchlist/queries/keys';
import { RetrieveBlacklistsResponse } from 'app/modules/lists/responses';
import { RetrieveBlacklistsPayload } from 'app/modules/lists/requests';

export const useGetMatchlists = (payload: RetrieveBlacklistsPayload) => {
  const hasReadMatchlistPermission = useSelector(
    selectHasReadMatchlistsPermission,
  );
  return useQuery({
    enabled: hasReadMatchlistPermission,
    queryFn: () =>
      post<RetrieveBlacklistsResponse>('/blacklists/list', payload),
    queryKey: MATCHLIST_QUERY_KEYS.getMatchlists(payload),
  });
};
